import BaseComponent from "@js/components/base_component.jsx";

class MuiUserRolesTable extends BaseComponent {

  render() {
    return this.props.users.length > 0 ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.name") }</th>
            <th className="column-name">{ t("headings.email") }</th>
            {
              !this.props.is_master_account &&
                <th className="column-name" style={{ width: "150px" }}>{ t("headings.role") }</th>
            }
            <th className="column-name">{ t("headings.status") }</th>
            <th className="column-actions" style={{ width: "175px" }}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification type={I18n.t("sections.users")} offerNew={ false } />
    );
  }

  _renderRows() {
    return this.props.users.map((user, i) => {
      return (
        <tr key={ i }>
          <td>{ user.name }</td>
          <td>{ user.email }</td>
          {
            !this.props.is_master_account &&
              <td>{ I18n.t(`monitor_user_roles.${ user.role }`) }</td>
          }
          <td>{ this._renderUserStatus(user) }</td>
          <td className="text-right index-buttons">
            { this._renderButtons(user) }
          </td>
        </tr>
      );
    });
  }

  _renderUserStatus(user) {
    if ( user.active ) {
      return <span>Active</span>;
    } else {
      let resendLinkUrl;

      if ( this.props.is_index ) {
        resendLinkUrl = Routes.resend_link_mui_user_role_path(user.user_role_id);
      } else {
        resendLinkUrl = Routes.resend_link_mui_sub_account_user_role_path(user.sub_account_id, user.user_role_id);
      }

      return (
        <span>
          Invited
          &nbsp;
          <ButtonWithIcon
            href={ resendLinkUrl }
            type="index"
            size="small"
          >
            Resend Link
          </ButtonWithIcon>
        </span>
      );
    }
  }

  _renderButtons(user) {
    let editUrl, viewUrl;

    if ( this.props.is_index ) {
      editUrl       = Routes.edit_mui_user_role_path(user.user_role_id, { return_to: window.location.href });
      viewUrl       = Routes.mui_user_role_path(user.user_role_id);
    } else {
      editUrl       = Routes.edit_mui_sub_account_user_role_path(user.sub_account_id, user.user_role_id, { return_to: window.location.href });
      viewUrl       = Routes.mui_sub_account_user_role_path(user.sub_account_id, user.user_role_id);
    }

    return (
      <div>
          <ButtonEdit
            href={ editUrl }
            size="small"
          />
          <ButtonView
            href={ viewUrl }
            size="small"
          />
      </div>
    );
  }

}

export default MuiUserRolesTable;
